module.exports = __webpack_public_path__ + "image-f73ba4b7f890.png";